module.exports = __webpack_public_path__ + "img/icon6.7031625c.png";